export enum Status {
  OK = "OK",
  FAILED = "FAILED",
  ERROR = "ERROR"
}